import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { VolunteerService } from "../services/volunteer.service";
import { SurveyService } from "../services/survey.service";
import { UsageReport } from "../models/usage-report.model";
import { VolunteerOpportunity } from "../models/volunteer-registration.model";
import { VolunteerEvent } from "../models/volunteer-event.model";
import { VolunteerActivity } from "../models/volunteer-activity.model";
import { VolunteerActivityDate } from "../models/volunteer-activity-date.model";
import { VolunteerRegistration } from "../models/volunteer.model";
import { LocalstorageService } from "../services/localstorage.service";
import { VolunteerDialogComponent } from "../dialogs/volunteer-dialog/volunteer-dialog.component";
import { VolunteerCalendarLegendDialogComponent } from "../dialogs/volunteer-dialog/volunteer-calendar-legend.component";
import { AuthDetails } from "../models/auth-details.model";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatDialog } from "@angular/material/dialog";
import {
  MatCalendarCellCssClasses,
  MatCalendar,
  MatDatepickerInputEvent,
} from "@angular/material/datepicker";
import * as moment from "moment";
import { VolunteerActivityShift } from "../models/shift.model";
import { VolunteerActivityResource } from "../models/volunteer-resource.model";
import {
  AvailableDate,
  VolunteerActivityVM,
  VolunteerEventDetailVM,
  VolunteerOpportunityVM,
  VolunteerShiftVM,
} from "../models/volunteer-opportunity.model";
import { ShiftDialogComponent } from "../dialogs/shift-dialog/shift-dialog.component";

@Component({
  selector: "app-volunteer-opportunity",
  templateUrl: "./volunteer-opportunity.component.html",
  styleUrls: ["./volunteer-opportunity.component.css"],
})
export class VolunteerOpportunityComponent implements OnInit {
  volunteerOpportunities: VolunteerOpportunityVM;
  volunteerEvent: VolunteerEventDetailVM;
  volunteerActivities: VolunteerActivityVM[];
  filteredVolunteerActivities: VolunteerActivityVM[];
  volunteerActivityDates: VolunteerActivityDate[];
  registrations: VolunteerRegistration[];
  shifts: VolunteerActivityShift[];
  activityResources: VolunteerActivityResource[];
  isVisible: boolean;
  eventStartDate: Date;
  eventEndDate: Date;
  dates = [];
  eventId: number;
  isChecked: false;
  authDetails: AuthDetails;
  isLoading = true;
  volunteerInNoParticipateList: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private volunteerService: VolunteerService,
    private localstorageService: LocalstorageService,
    private dialog: MatDialog
  ) {}

  startDate = new Date();
  ngOnInit() {
    this.isLoading = true;
    this.startDate.setDate(this.startDate.getDate() + 1);
    this.authDetails = this.localstorageService.getAuth();
    this.eventId = Number(this.router.url.split("/").pop());
    this.volunteerActivityDates = [];

    // this.volunteerService
    //   .getVolunteerDetails(this.authDetails.employeeInfo.corpId, this.eventId)
    //   .subscribe((responseData) => {
    //     this.volunteerOpportunities = responseData;
    //     this.volunteerActivities = responseData.volunteerActivities;
    //     this.volunteerActivityDates = responseData.volunteerActivityDates;
    //     this.registeredActivityDates = responseData.registeredActivityDates;
    //     this.volunteerEvent = responseData.volunteerEventDetail;
    //     this.registrations = responseData.registrations;
    //     this.shifts = responseData.VolunteerActivityShifts;
    //     this.activityResources = responseData.VolunteerActivityResources;
    //     console.log(this.volunteerOpportunities);
    //   });
    this.volunteerService
      .getVolunteerDetails(this.authDetails.employeeInfo.corpId, this.eventId)
      .subscribe((responseData) => {
        this.volunteerOpportunities = responseData;
        this.volunteerEvent = this.volunteerOpportunities.volunteerEventDetail;
        this.volunteerActivities = this.volunteerOpportunities.volunteerActivities;
        this.filterActivities(null);//initialize filtered array with all values.
        this.registrations = responseData.registrations;
        console.log(this.volunteerOpportunities);
        this.isLoading = false;
        this.volunteerInNoParticipateList = responseData.volunteerInNoParticipateList;
      });

    this.isVisible = true;
  }

  filterActivities(dateFilter: Date) {
    this.filteredVolunteerActivities = [];
    this.volunteerActivities.forEach(a => {
      if (dateFilter == null) {
        this.filteredVolunteerActivities.push({ ...a, volunteerShifts: [...a.volunteerShifts] });
      }
      else {
        let dateAvailibilites = this.volunteerOpportunities.allAvailableDates
          .filter(d => this.isDateEqual(new Date(d.activityDate), dateFilter));
        let isActivityAvailable = dateAvailibilites.find(d => d.volunteerActivityId == a.volunteerActivityId);
        if (isActivityAvailable) {
          let tempShifts = [];
          a.volunteerShifts.forEach(s => {
            let isShiftAvailable = dateAvailibilites.find(d => d.volunteerActivityId == a.volunteerActivityId
              && d.volActivityShiftID == s.shiftId);
            if (isShiftAvailable) {
              tempShifts.push({ ...s });
            }
          });
          if (tempShifts.length > 0) {
            this.filteredVolunteerActivities.push({ ...a, volunteerShifts: tempShifts });
          }
        }
      }
    });
  }

  getColor(index) {
    return index % 2 == 0 ? "mat_primary" : "mat_secondary";
  }

  setValue(id, e) {
    if (e.checked) {
      var activityDateId = id;
    }
  }

  showAllDates(){
    this.selectedDateFilter = null;
    this.filterActivities(this.selectedDateFilter);
  }

  selectedDateFilter: Date;
  onSpecifyDateChange(event: MatDatepickerInputEvent<Date>) {
    this.selectedDateFilter = event.value;
    console.log(this.selectedDateFilter);
    this.filterActivities(this.selectedDateFilter);
  }

  openDialog(eventId) {
    var message = "";
    var removeMessage = "";
    var isShow = true;
    var activityDateIds = [];
    var activityDates = [];
    var activityDatesOnly = [];
    var removeActivityDateIds = [];
    var removeActivityDates = [];
    var removeActivityDatesOnly = [];
    var removeRegistrationIds = [];
    let registrations = this.registrations;
    let activities = this.volunteerActivities;
    var corpId = this.authDetails.employeeInfo.corpId;
    var today = new Date();
    var questions = [];

    this.volunteerActivityDates.forEach(function (actDate) {
      console.log('ACTDATE=', actDate);
      let activityName = activities.filter(function (activity) {
        return activity.volunteerActivityId == actDate.volunteerActivityId;
      });
      let shiftName = activityName[0].volunteerShifts.filter(function (shift) {
        return shift.shiftId == actDate.volActivityShiftID;
      });
      if (
        !registrations.some(
          (r) => r.volunteerActivityDateId === actDate.volunteerActivityDateId
        )
      ) {
        if (actDate.isChecked) {
          activityDatesOnly.push(moment(actDate.activityDate).format("L"));
          activityDateIds.push(actDate.volunteerActivityDateId);
          activityDates.push(
            "" +
              activityName[0].volunteerActivityId + "|" +
              activityName[0].activityTitle +
              ", " +
            moment(actDate.activityDate).format("MMM Do YYYY") +
            ", " +
            shiftName[0].shiftNameWithTime
          );
        }
      }

      if (
        registrations.some(
          (r) =>
            r.volunteerActivityDateId === actDate.volunteerActivityDateId &&
            r.volunteerCorpId === corpId
        )
      ) {
        if (!actDate.isChecked) {
          removeActivityDatesOnly.push(moment(actDate.activityDate).format("L"));
          removeActivityDateIds.push(actDate.volunteerActivityDateId);
          removeActivityDates.push(
            "" +
              activityName[0].activityTitle +
              ", " +
            moment(actDate.activityDate).format("MMM Do YYYY") +
            ", " +
            shiftName[0].shiftNameWithTime
          );
          let registration = registrations.filter(function (registration) {
            return (
              registration.volunteerActivityDateId ==
                actDate.volunteerActivityDateId &&
              registration.volunteerCorpId == corpId
            );
          });
          removeRegistrationIds.push(registration[0].volunteerRegId);
        }
      }
      console.log(activityName[0]);
      var question = activityName[0].volunteerActivityQuestions.find(q => q.volunteerActivityId == actDate.volunteerActivityId);
      if (question.volunteerActivityId == actDate.volunteerActivityId) {
        questions.push(question);
      }
    });

    var tempArr = [];

    //Remove Duplicates from questions arrary
    questions.filter(f => {
      var i = tempArr.findIndex(x => (x.volunteerActivityId == f.volunteerActivityId &&
        x.volunteerActivityQuestionId == f.volunteerActivityQuestionId &&
        x.volunteerActivityQuestionRequired == f.volunteerActivityQuestionRequired &&
        x.volunteerActivityQuestionText == f.volunteerActivityQuestionText));

      if (i <= -1) {
        tempArr.push(f);
      }
      return null;
    });
    questions = tempArr;

    if (activityDateIds.length === 0) {
      message =
        "You have not signed up for anything new. Please cancel and click on a date to sign up for that date.";
    } else {
      message =
        "Thank you for volunteering. You are signed up for the following activities.";
    }

    if (removeActivityDateIds.length !== 0) {
      // let datesLessThan24HoursAway = removeActivityDates.some((h) => h.includes(moment().add(1, 'days').format("MMM Do YYYY")));
      // if (datesLessThan24HoursAway) {
      //   removeMessage = "You cannot remove yourself from a shift that is less than 24hrs away.";
      //   isShow = false;
      // }      else
       {
        removeMessage = "You will be removed from the following activity dates.";
      }
    }

    const dialogRef = this.dialog.open(VolunteerDialogComponent, {
      width: "550px",
      data: {
        name: "Submit registration",
        message: message,
        eventTitle: this.volunteerOpportunities.volunteerEventDetail.eventTitle,
        corpId: corpId,
        removeMessage: removeMessage,
        actDateIds: activityDateIds,
        actDates: activityDates,
        actDatesOnly: activityDatesOnly,
        registrations: registrations,
        tmPhone: this.authDetails.employeeInfo.cellPhone,
        remDateIds: removeActivityDateIds,
        remDates: removeActivityDates,
        remDatesOnly: removeActivityDatesOnly,
        remRegIds: removeRegistrationIds,
        modifiedActivityDates: this.volunteerActivityDates,
        isShow: isShow,
        actQuestions: questions
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed", result);
      if (result == "skipped") {
      }
    });
  }

  isDateEqual(d1: Date, d2: Date) {
    return (
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear()
    );
  }

  selectedDate: Date;
  @ViewChildren('calendar') calendars: QueryList<ElementRef>;
  onSelect(
    event: any,
    calendar: any,
    activity: VolunteerActivityVM,
    shift: VolunteerShiftVM
  ) {
    
    this.selectedDate = event;
    //console.log(event, nextDay);
    
    let foundSelectedDate = this.volunteerActivityDates.find(
      (v) =>
        v.volunteerActivityId == activity.volunteerActivityId && v.volActivityShiftID == shift.shiftId && this.isDateEqual(new Date(v.activityDate), this.selectedDate)
    );
    if (foundSelectedDate) {
      //foundSelectedDate.isChecked = !foundSelectedDate.isChecked;
      this.volunteerActivityDates = this.volunteerActivityDates.filter(d => !this.isDateEqual(d.activityDate, this.selectedDate));
    } else {
      
      if(this.isDateAlreadyChoosen(this.selectedDate)) return; //if date is already selected in other calendar just return.

      let foundDateId = shift.availableDates.find(
        (v) =>
          v.volunteerActivityId == activity.volunteerActivityId && this.isDateEqual(new Date(v.activityDate), this.selectedDate)
      );
      let foundExistingReg = this.registrations
          .find((v) => v.volActivityShiftID === shift.shiftId && this.isDateEqual(new Date(v.activityDate), this.selectedDate)
      );
      if (foundDateId) { //adding date
        
        if (foundExistingReg) {
          let nextDay = moment().add(1, 'days').toDate();
          if (this.isDateEqual(this.selectedDate, nextDay)) {
            console.log('24 hours');
            this.openShift24HoursCancelMessage();
            return;
          }
        }
        // else {
        //   let next12HoursDay = moment().add(12, 'hours').toDate();
        //   if (this.isDateEqual(this.selectedDate, next12HoursDay)) {
        //     console.log('12 hours');
        //     this.openShift12HoursBookMessage();
        //     return;
        //   }
        // }
        this.volunteerActivityDates.push({
          volunteerActivityDateId: foundDateId.volunteerActivityDateId,
          isChecked: foundExistingReg ? false : true,
          activityDate: this.selectedDate,
          volunteerActivityId: activity.volunteerActivityId,
          volActivityShiftID: shift.shiftId,
        } as VolunteerActivityDate);
      }
      else { //removing existing one
        if (foundExistingReg) {
          let nextDay = moment().add(1, 'days').toDate();
          if (this.isDateEqual(this.selectedDate, nextDay)) {
            console.log('24-4 hours');
            this.openShift24HoursCancelMessage();
            return;
          }
          this.volunteerActivityDates.push({
            volunteerActivityDateId: foundExistingReg.volunteerActivityDateId,
            isChecked: false,
            activityDate: this.selectedDate, 
            volunteerActivityId: activity.volunteerActivityId,
            volActivityShiftID: shift.shiftId,
          } as VolunteerActivityDate);
          const highlightDateId = this.registrations
            .filter((r) => r.volActivityShiftID === shift.shiftId && r.volunteerActivityDateId == foundExistingReg.volunteerActivityDateId);
          const index = this.registrations.indexOf(highlightDateId[0]);
         
          shift.availableDates.push({activityDate: moment(this.selectedDate).format("YYYY-MM-DD")+"T00:00:00"} as AvailableDate)
          console.log('avldate', shift.availableDates)
        }

      }

      
    }
    console.log('selected dates', this.volunteerActivityDates)
    
    this.calendars.forEach((elementCalendar:any) => {
      elementCalendar.updateTodaysDate();
    });
  }

  // dateFilter = (dm: any): boolean => {
  //   console.log(dm);
  //   return dm.getDay() !== 0 && dm.getDay() !== 6;
  // };

  isDateAlreadyChoosen(date:any): boolean{
    const dateTaken = this.volunteerActivityDates.find(
      (v) =>
        v.isChecked === true && this.isDateEqual(new Date(v.activityDate), date)
    );
    
    return dateTaken ? true: false;
  }

  isDateAvailabe(shift: VolunteerShiftVM, date: any) {
    const availableDate = shift.availableDates
      //.filter((v) => v.volunteerActivityId == activity.volunteerActivityId)
      .map((v) => new Date(v.activityDate))
      //.map((strDate) => new Date(strDate))
      .some(
        (d) => this.isDateEqual(d, date)
      );

    if (availableDate) {
      const removedDateIdFromShift = this.volunteerActivityDates
        .filter((r) => r.isChecked === false).map(v => v.volunteerActivityDateId);

      const datesAlreadyRegistered = this.registrations
        .some((r) => this.isDateEqual(new Date(r.activityDate), date) && !removedDateIdFromShift.includes(r.volunteerActivityDateId));


      return !(this.isDateAlreadyChoosen(date) || datesAlreadyRegistered);
    }
    // console.log(
    //   shift.shiftId,
    //   date,
    //   "available dates",
    //   availableDate
    // );

    return availableDate;
  }

  dateClass(activity: VolunteerActivityVM, shift: VolunteerShiftVM) {
    // console.log('shift', shift);
    return (date: Date): MatCalendarCellCssClasses => {
      let removedDateIdFromShift = this.volunteerActivityDates
      .filter((r) => r.isChecked === false).map(v=>v.volunteerActivityDateId);

      let datesToHighlight = this.registrations
      .filter((r) => r.volActivityShiftID === shift.shiftId && !removedDateIdFromShift.includes(r.volunteerActivityDateId));

      const highlightDate = datesToHighlight.map((v) => new Date(v.activityDate))
        //.map((strDate) => new Date(strDate))
        .some(
          (d) =>this.isDateEqual(d, date)
        );

      const selectedDate = this.volunteerActivityDates
        .filter((r) => r.isChecked === true && r.volActivityShiftID==shift.shiftId)
        .map((v) => new Date(v.activityDate))
        //.map((strDate) => new Date(strDate))
        .some(
          (d) =>this.isDateEqual(d, date)
        );

      return highlightDate || selectedDate
        ? "special-date"
        : !this.isDateAvailabe(shift, date)
        ? "date-taken"
        : "";
    };
  }
  openLegend() {
    const dialogRef = this.dialog.open(VolunteerCalendarLegendDialogComponent, {
      width: "400px",
      data: {
        
      },
    });
  }
  openShift24HoursCancelMessage() {
    const dialogRef = this.dialog.open(ShiftDialogComponent, {
      width: "400px",
      data: {
        message:"If you need to cancel within 24 hours of the start of the shift, please contact the appropriate scheduling team. Contact info can be found on the Emergency Staffing homepage for Emergency Staffing."
      },
    });
  }
  openShift12HoursBookMessage() {
    const dialogRef = this.dialog.open(ShiftDialogComponent, {
      width: "400px",
      data: {
        message:"If you need to book within 12 hours of the start of the shift, please contact the appropriate scheduling team. Contact info can be found on the Emergency Staffing homepage for Emergency Staffing."
      },
    });
  }

  onDescriptionLinkEvent(event) {
    event.stopPropagation();
 }
}
